import { action, computed, makeObservable, observable } from 'mobx'
import { getValue, isPending } from 'mobx-async'

import { getHotelOmniSearchResults } from '../../stores/api/hotelArriere'

class _HotelOmniSearchStore {
  private _searchTerm?: string
  private _hotelId?: string

  constructor() {
    makeObservable<
      _HotelOmniSearchStore,
      '_searchTerm' | '_hotelId' | 'hotelOmniSearchBookingResults'
    >(this, {
      _searchTerm: observable,
      _hotelId: observable,
      hotelOmniSearchBookingResults: computed,
      hotelOmniSearchBookings: computed,
      isLoadingResults: computed,
      setSearchTermParams: action.bound,
      setSearchHotelId: action.bound,
    })
  }

  private get hotelOmniSearchBookingResults() {
    if (this._searchTerm && this._hotelId) {
      return getHotelOmniSearchResults(this._hotelId, this._searchTerm)
    } else {
      return Promise.resolve(undefined)
    }
  }

  get hotelOmniSearchBookings() {
    return getValue(this.hotelOmniSearchBookingResults)
  }

  get isLoadingResults() {
    return isPending(this.hotelOmniSearchBookingResults)
  }

  setSearchTermParams(searchTerm?: string) {
    this._searchTerm = searchTerm
  }

  setSearchHotelId(hotelId: string) {
    this._hotelId = hotelId
  }
}

export const hotelOmniSearchStore = new _HotelOmniSearchStore()
